var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGpay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.155 8.37137H18.4166V8.33333H10.1667V12H15.3472C14.5914 14.1344 12.5605 15.6667 10.1667 15.6667C7.12929 15.6667 4.66666 13.204 4.66666 10.1667C4.66666 7.12929 7.12929 4.66666 10.1667 4.66666C11.5687 4.66666 12.8442 5.19558 13.8154 6.05954L16.4082 3.46675C14.7711 1.94096 12.5812 1 10.1667 1C5.10437 1 1 5.10437 1 10.1667C1 15.2289 5.10437 19.3333 10.1667 19.3333C15.2289 19.3333 19.3333 15.2289 19.3333 10.1667C19.3333 9.55203 19.2701 8.95208 19.155 8.37137Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05704 5.90004L5.06874 8.10874C5.88366 6.09116 7.85724 4.66666 10.1668 4.66666C11.5688 4.66666 12.8444 5.19558 13.8156 6.05954L16.4084 3.46675C14.7712 1.94096 12.5813 1 10.1668 1C6.64587 1 3.59245 2.98779 2.05704 5.90004Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1666 19.333C12.5343 19.333 14.6858 18.4269 16.3124 16.9533L13.4753 14.5526C12.524 15.276 11.3617 15.6673 10.1666 15.6663C7.78235 15.6663 5.75789 14.146 4.99523 12.0244L2.00598 14.3275C3.52306 17.2962 6.60398 19.333 10.1666 19.333Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1552 8.37105H18.4169V8.33301H10.1669V11.9997H15.3474C14.9859 13.0155 14.3347 13.9032 13.4742 14.553L13.4756 14.5521L16.3127 16.9529C16.1119 17.1353 19.3335 14.7497 19.3335 10.1663C19.3335 9.55172 19.2703 8.95176 19.1552 8.37105Z",
    fill: "#1976D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpay);
export default __webpack_public_path__ + "static/media/gpay.f30310a8c373b59f639e46bc6a58fb44.svg";
export { ForwardRef as ReactComponent };